import { api } from "../Components/base_service";


const LoginService = {
  login: async (email, password) => {
    try {
      const data = await api.post("login?userType=Customer", {
        email,
        password,
      });

      if (data.errorCode === "0") {
        const { accessToken, refreshToken, name, role } = data.responseBody;

        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem("userName", name);
        localStorage.setItem("userRole", role);

        return { success: true };
      } else {
        return { success: false, message: data.errorMessage || "Login failed" };
      }
    } catch (err) {
      console.error("Login error:", err.message);
      return {
        success: false,
        message: err.message || "Network error or server not reachable",
      };
    }
  },

  register: async (userData) => {
    try {
      const res = await api.post("register", userData);
      return res;
    } catch (err) {
      throw err;
    }
  },

  logout: () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userName");
    localStorage.removeItem("userRole");
  },

  getUserDetails: async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        return { success: false, message: "No access token found" };
      }

      const data = await api.get("api/customer/myDetails", {});

      // Log the response to inspect the structure
      console.log("API Response:", data);

      // Check if errorCode is "0" as per the response
      if (data.errorCode === "0") {
        // Store the response in localStorage if success
        localStorage.setItem("user", JSON.stringify(data.responseBody));

        return { success: true, data: data.responseBody }; // Return the user details
      } else {
        return {
          success: false,
          message: data?.errorMessage || "Failed to fetch user details",
        };
      }
    } catch (err) {
      console.error("User fetch error:", err.message);
      return {
        success: false,
        message:
          err.message || "Something went wrong while fetching user details",
      };
    }
  },

  getCurrentUser : () => {
  const savedUser = localStorage.getItem("user");
  if (!savedUser) return null;

  try {
    return JSON.parse(savedUser);
  } catch (err) {
    console.error("Failed to parse user from localStorage", err);
    return null;
  }
}
};

export default LoginService;



